import React from 'react'
import './Policies.scss'
import { Policies } from '../../Components'

const PoliciesPage = () => {
  return (
    <div className='Policies'>
      <Policies />
    </div>
  )
}

export default PoliciesPage
